<template>
  <div>
    <v-sheet
      color="rgba(247, 219, 209, 0.4)">
      <v-container
        fluid>
        <v-row
          justify=center>
          <v-col
            cols=12
            sm=8
            >
            <v-choose-lesson-body/>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import VChooseLessonBody from '@/components/pages/lp/contents/VChooseLessonBody.vue'


export default {
  components: {
    VChooseLessonBody
  },
  data () {
    return {

    }
  },
  async mounted () {

  }
}
</script>
